module.exports = __webpack_public_path__ + "media/images/bg-12b304f1e83b0fd4fc108e061d453651.jpg";